import { useState } from "react";
import { ApiError, account, type User } from "../../../api/client";

export function HelpView({ user }: { user: User }) {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  async function send() {
    try {
      await account.support({ name: `${user.first_name} ${user.last_name}`.trim() || user.username, from_email: user.email ?? "", subject: "Help form", message });
      setStatus("Sent. Thanks!");
      setMessage("");
    } catch (e) {
      setStatus(e instanceof ApiError ? e.message : "Could not send.");
    }
  }
  return (
    <div className="HelpView shown">
      <div className="content">
        <div className="topContent">
          <div className="heading" />
          <div className="innerContent">
            <h2>INTRODUCTION TO GEARGRAMS</h2>
            <hr />
            <div className="player">
              <iframe title="Introduction to GearGrams" src="https://player.vimeo.com/video/130372726" width="750" height="421" frameBorder="0" allowFullScreen />
            </div>
          </div>
        </div>
        <div className="middleContent">
          <div className="heading" />
          <div className="innerContent">
            <h2>CONTACT</h2>
            <hr />
            <p>
              Send any questions to <a href="mailto:help@geargrams.com">help@geargrams.com</a> or fill out the form below
            </p>
            <label>Message:</label>
            <br />
            <textarea aria-label="Message" value={message} onChange={(e) => setMessage(e.target.value)} />
            <br />
            <button onClick={send}>Send</button> <span role="status">{status}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
